interface FormatNullableCurrencyOptions {
  currency?: string | null;
  locale?: string;
  fallback?: string | null;
}

/**
 * Formats a nullable/unknown currency value with `Intl.NumberFormat`.
 *
 * Returns `fallback` when `value` is `null`/`undefined`, not a finite number,
 * or when `currency` is missing. Numeric strings are supported, and `0` is
 * treated as a valid amount (it will be formatted, not treated as empty).
 */
export function formatNullableCurrency(
  value: unknown,
  { currency, locale = "en-CA", fallback = "" }: FormatNullableCurrencyOptions
): string | null {
  if (value == null || !currency) {
    return fallback;
  }

  let numericValue: number;
  try {
    numericValue = Number(value);
  } catch {
    return fallback;
  }

  if (!Number.isFinite(numericValue)) {
    return fallback;
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(numericValue);
  } catch {
    return fallback;
  }
}
